import React from 'react'
import ProjectFeed from '../components/Projects/ProjectFeed/ProjectFeed'
import Footer from '../layout/Footer'

function Project() {
  return (
    <>
  <div className='my-8 py-5 mx-3 sm:mx-6 lg:mx-8 text-white'>
        <ProjectFeed />
        
      </div>
      <Footer />
    </>
  )
}

export default Project
